import * as React from "react";
import { Modal, Button } from "semantic-ui-react";

interface Props {
    onClose: () => void;
}

const OutstandingPpqDeclarationMessage: React.FunctionComponent<Props> = (props) => {
    return (
        <>
            <Modal.Content>
                You cannot complete these HS Results until you have reviewed the PPQ Declaration Task
            </Modal.Content>
            <Modal.Actions>
                <Button content="Close" onClick={props.onClose} />
            </Modal.Actions>
        </>
    );
};

export { OutstandingPpqDeclarationMessage };
